<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>{{ $t("modal.oopsSelectYourTable") }}</v-card-title>
      <v-card-text>
        <v-select
          :items="qrCollection"
          item-text="table"
          item-value="table"
          outlined
          :label="$t('modal.selectYourTable')"
          v-model="selectedQr"
        ></v-select>
      </v-card-text>
      <v-card-actions class="flex justify-end">
        <v-btn outlined text @click="setTableQR">
          {{ $t("common.done") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { qrCollection } from "@/collections/qrs";

export default {
  data() {
    return {
      dialog: false,
      qrCollection: [],
      selectedQr: null
    };
  },
  firestore() {
    return {
      qrCollection: qrCollection.where("active", "==", true)
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    setTableQR() {
      this.$store.commit("setTableQR", this.selectedQr);
      this.$emit("submit", this.selectedQr);
      this.dialog = false;
    }
  }
};
</script>

<style></style>
